import type {
  IDiscreteCategoricalValue,
  INominalCategoricalValue,
} from "./categorical-value";
import { categoricalValueToString } from "./categorical-value";
import type { IEmpiricalFormulaValue } from "./empirical-formula-value";
import { empiricalFormulaValueToString } from "./empirical-formula-value";
import type { IInChiValue } from "./in-chi-value";
import { inChiValueToString } from "./in-chi-value";
import type {
  INominalIntegerValue,
  IUniformIntegerValue,
} from "./integer-value";
import { integerValueToString } from "./integer-value";
import type { INominalCompositionValue } from "./nominal-composition-value";
import { nominalCompositionValueToString } from "./nominal-composition-value";
import type {
  INominalRealValue,
  INormalRealValue,
  IUniformRealValue,
} from "./real-value";
import { realValueRoundedToString } from "./real-value";
import type { ISmilesValue } from "./smiles-value";
import { smilesValueToString } from "./smiles-value";

export * from "./categorical-value";
export * from "./empirical-formula-value";
export * from "./in-chi-value";
export * from "./integer-value";
export * from "./nominal-composition-value";
export * from "./real-value";
export * from "./smiles-value";

export type IAttributeValue =
  | INominalIntegerValue
  | IUniformIntegerValue
  | IDiscreteCategoricalValue
  | INominalCategoricalValue
  | INormalRealValue
  | IUniformRealValue
  | INominalRealValue
  | INominalCompositionValue
  | IEmpiricalFormulaValue
  | ISmilesValue
  | IInChiValue;

export function valueToString(value: IAttributeValue) {
  switch (value.type) {
    case "discrete_categorical":
    case "nominal_categorical":
      return categoricalValueToString(value);
    case "normal_real":
    case "nominal_real":
    case "uniform_real":
      return realValueRoundedToString(value);
    case "nominal_composition":
      return nominalCompositionValueToString(value);
    case "nominal_integer":
    case "uniform_integer":
      return integerValueToString(value);
    case "empirical_formula":
      return empiricalFormulaValueToString(value);
    case "inchi":
      return inChiValueToString(value);
    case "smiles":
      return smilesValueToString(value);
  }
}
